<div
  class="d-flex row align-items-center topbar"
  [ngClass]="
    (showBackArrow$ | async) ? 'justify-content-between' : 'justify-content-end'
  "
>
  <button
    *ngIf="showBackArrow$ | async"
    type="button"
    class="d-flex justify-content-center align-items-center btn back-button"
    (click)="backnav()"
  >
    <i class="pi pi-angle-left"></i>
  </button>
  <button
    type="button"
    class="d-flex d-md-none w-auto h-100 px-4 justify-content-center align-items-center btn"
    aria-label="Toggle menu"
    i18n-aria-label="Header's menu icon"
    (click)="repo.toggleMenuOpened()"
  >
    <img src="assets/img/menu.svg" class="nav-icon" />
  </button>
</div>
